var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LockSvg from './lock-01.icon.svg';
export const LockIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LockSvg }));
_react_refresh_temp_1 = LockIcon;
$RefreshReg$(_react_refresh_temp_1, "LockIcon");
